export default "__VITE_ASSET__b$pibYn7__"